import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { StepLayout } from 'components/StepLayout/StepLayout';
import { SelectCatalogSizeStepOptions } from './components/SelectCatalogSizeStepOptions';
import { useAppStore } from 'stores/state';
import { BI_ACTION_NAME, BI_STEP_NAME } from 'config/bi-events';
import { biEvents } from 'api/bi-events';
import { StepId } from 'config/flow';

export const SelectCatalogSizeStep: FC = () => {
  const { t } = useTranslation();

  const catalogSize = useAppStore((state) => state.catalogSize);

  return (
    <StepLayout
      nextButtonProps={{ label: t('select-catalog-size-step.actions.next-button'), disabled: !catalogSize }}
      description={t('select-catalog-size-step.description')}
      title={t('select-catalog-size-step.title')}
      onNext={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.SelectCatalogSize],
          action: BI_ACTION_NAME.NEXT,
          value: catalogSize,
        });
      }}
    >
      <SelectCatalogSizeStepOptions />
    </StepLayout>
  );
};
